// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__NZpDp","inputWrap":"styles_inputWrap__3dfFS","input":"styles_input__1mTZo"};